import { defaultEntityState } from '../entity';
import { IProjectGroup } from './project-group.entity';
import { projectDetailActions } from '@app/core/actions/project-detail.actions';
import {
  mergeEntityState,
  removeEntities,
  removeEntitiesByFilter,
} from '../entity.helpers';
import { createReducer, on } from '@ngrx/store';
import { entityKey } from '../entity-name-map';

export const projectGroupEntityReducer = createReducer(
  defaultEntityState<IProjectGroup>(),
  on(
    projectDetailActions.created,
    projectDetailActions.detailLoaded,
    projectDetailActions.projectForInvitationRetrieved,
    projectDetailActions.requestToJoinProjectResponseReceivedAndGranted,
    projectDetailActions.invitationsBulkRevokedSuccessfully,
    projectDetailActions.joinRequestsResponseSent,
    projectDetailActions.projectUpdated,
    projectDetailActions.projectListingUpdated,
    projectDetailActions.registered,
    projectDetailActions.projectMembershipGroupsUpdated,
    (state, props) => mergeEntityState(entityKey.projectGroups, state, props)
  ),
  on(projectDetailActions.projectDeleted, (state, props) =>
    removeEntitiesByFilter(
      state,
      (projChild) => projChild.projectId === props.projectId
    )
  )
);
